/**
 * API Configuration
 * Backend URL - change this for production
 */
export const API_CONFIG = {
  BASE_URL: 'https://web3-pos-v2.gdbok.workers.dev', // Change to your backend URL
  TIMEOUT: 30000 // 30 seconds
};

/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  SCAN_QR: (txRef) => `/api/scan-qr/${txRef}`,
  SELECT_SOURCE_CHAIN: '/api/select-source-chain',
  CHECK_PAYMENT: (txRef) => `/api/check-payment/${txRef}`,
  CREATE_PAYMENT: '/api/create-payment',
  EXECUTE_PAYMENT: '/api/execute-payment',  // ✅ ADD THIS LINE
  
};